import { ref, onMounted, onBeforeUnmount, computed } from 'vue-demi';
import FEGORender from '@futuweb/fego-render';
import { TIME_LIMIT, DISPLAY_TYPE } from '../../constants';
import Cache from '../../fego/Cache';
import { throttle } from '../../fego/utils';
const { useEnv } = require('@fegobull/webapi').use;
const { isPreRender } = useEnv();

const { store: { variable }, library } = FEGORender;
const { dayjs } = library;

export default function useJudgeOverFirstScreen({ enableCloseBtn, closeTimeLimit }) {
    const displayBox = ref(DISPLAY_TYPE.HIDDEN);
    const urlSuffix = variable.data.URL_SUFFIX;
    const cache = new Cache({
        prefix: `fixed-box-${urlSuffix}`
    });
    // 关闭标识
    const closeSign = computed(() => {
        return `close_${closeTimeLimit}`;
    });

    /**
     * 判断是否超过首屏，超过则展示
     */
    const judgeOverFirstScreen = () => {
        const scrollElement = document.documentElement || document.body;
        const currentOffset = scrollElement.scrollTop;
        const overFirstScreen = currentOffset > scrollElement.clientHeight;
        const flag = overFirstScreen ? DISPLAY_TYPE.DISPLAY : DISPLAY_TYPE.HIDDEN;

        return flag;
    };

    /**
     * 初始化显示状态
     */
    const initDisplayStatus = () => {
        let flag = DISPLAY_TYPE.HIDDEN;
        if (enableCloseBtn) {
            flag = DISPLAY_TYPE.CLOSE;
            const cacheStatus = cache.getCacheStatus(closeSign.value);
            switch (closeTimeLimit) {
                case TIME_LIMIT.DAY:
                    const expTime = dayjs(cacheStatus * 1e3 + 24 * 60 * 60 * 1000).unix();
                    const now = dayjs().unix();
                    if (expTime < now) {
                        flag = DISPLAY_TYPE.HIDDEN;
                    }
                    break;
                case TIME_LIMIT.FOREVER:
                    flag = cacheStatus ? DISPLAY_TYPE.CLOSE : DISPLAY_TYPE.HIDDEN;
                    break;
                default:
                    // 默认隐藏，防止闪动，由滚动监听器判断
                    flag = DISPLAY_TYPE.HIDDEN;
                    break;
            }
        }
        if (flag !== DISPLAY_TYPE.CLOSE) {
            flag = judgeOverFirstScreen();
        }
        displayBox.value = flag;
    };

    /**
     * 滚动回调
     */
    let handleScroll = () => {
        // 弹窗已关闭时 忽略
        if (displayBox.value === DISPLAY_TYPE.CLOSE) {
            removeScrollListener();
            return;
        }
        const flag = judgeOverFirstScreen();
        displayBox.value = flag;
    };

    /**
     * 移除滚动监听器
     */
    const removeScrollListener = () => {
        window.removeEventListener('scroll', handleScroll);
    };

    /**
     * 初始化延迟显示的滚动监听
     */
    const initScrollWatcher = () => {
        // 函数节流
        handleScroll = throttle(handleScroll, 50);

        window.addEventListener('scroll', handleScroll);
    };


    /**
     * 关闭容器
     */
    const close = () => {
        // 缓存关闭状态
        switch (closeTimeLimit) {
            case TIME_LIMIT.DAY:
                cache.setCacheStatus(closeSign.value, dayjs().unix());
                break;
            case TIME_LIMIT.FOREVER:
                cache.setCacheStatus(closeSign.value, '1');
                break;
            default:
                break;
        }
        displayBox.value = DISPLAY_TYPE.CLOSE;

        removeScrollListener();
    };

    onMounted(() => {
        if (isPreRender) {
            return;
        }
        // 初始化显示状态
        initDisplayStatus();
        // 初始化滚动事件
        initScrollWatcher();
    });
    onBeforeUnmount(() => {
        removeScrollListener();
    });

    return {
        displayBox,
        close
    };
}
